const AuthLogin = () => import('@/components/auth/auth-login')
const AuthInner = () => import('@/components/auth/auth-inner')

const AccountSystem = () => import('@/components/account/account-system')
const AccountUsers = () => import('@/components/account/account-users')
const AccountWxverify = () => import('@/components/account/account-wxverify')

const CardList = () => import('@/components/card/card-list')
const CardView = () => import('@/components/card/card-view')
const CardEdit = () => import('@/components/card/card-edit')
const CardMemberList = () => import('@/components/card/card-memberList')
const CardMemberDet = () => import('@/components/card/card-memberDet')

const Default = () => import('@/components/default')

export default {
  routes: [
    {
      path: '/login',
      name: 'login',
      alias: '',
      component: AuthLogin,
    },
    {
      path: '/inner',
      name: 'inner',
      component: AuthInner,
      children: [
        {
          path: 'system',
          name: 'system',
          component: AccountSystem,
        },
        {
          path: 'users',
          name: 'users',
          component: AccountUsers,
          alias: '',
        },
        {
          path: 'wxverify',
          name: 'wxverify',
          component: AccountWxverify,
        },
        {
          path: 'cards',
          name: 'cards',
          component: CardList,
        },
        {
          path: 'cardView',
          name: 'cardView',
          component: CardView,
        },
        {
          path: 'cardEdit',
          name: 'cardEdit',
          component: CardEdit,
        },
        {
          path: 'cardMemberList',
          name: 'cardMemberList',
          component: CardMemberList,
        },
        {
          path: 'cardMemberDet',
          name: 'cardMemberDet',
          component: CardMemberDet,
        },
        {
          path: '*',
          name: 'innerDefault',
          component: Default,
        },
      ],
    },
    {
      path: '*',
      name: 'default',
      component: Default,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/router/index.js